import React from "react";
import { Typography, Button, Box } from "@mui/material";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by Error Boundary: ", error, errorInfo);
  }

  componentDidMount() {
    // Check sessionStorage for the 'isReloaded' flag
    const isReloaded = sessionStorage.getItem("isReloaded");

    if (isReloaded === null) {
      // If the flag doesn't exist, reload the page and set the flag to true
      sessionStorage.setItem("isReloaded", "true");
      window.location.reload();
    } else if (isReloaded === "false") {
      // If the flag exists and is false, we prevent any further automatic reloads
      // The user can manually click "Try Again" to reset
    }
  }

  handleTryAgain = () => {
    // Reset the error state and set isReloaded to false in sessionStorage
    this.setState({ hasError: false });
    sessionStorage.setItem("isReloaded", "false");
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          height="100vh"
        >
          <Typography variant="h3" gutterBottom>
            Oops! Something went wrong.
          </Typography>
          <Typography variant="body1" paragraph>
            We're working on getting this fixed as soon as we can.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleTryAgain}
          >
            Try Again


            
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
